import {
  ExtendedArchetype,
  ExtendedPattern,
  ExtendedScale,
} from "@/models/sharedModels";

type TraitElement = ExtendedScale | ExtendedPattern | ExtendedArchetype;

export function filterElements(element: TraitElement, traitType: any[]) {
  if (traitType.includes(element.traitContent.traitType)) {
    return true;
  } else {
    return false;
  }
}

export function filterByDimension(element: TraitElement, dimension: string[]) {
  if (dimension.length === 0) {
    return true;
  }
  if (element.traitContent.traitType === "pattern") {
    // @ts-ignore
    if (dimension.includes(element.dimensionSlugs[0])) {
      return true;
    } else {
      return false;
    }
  } else {
    // @ts-ignore
    if (dimension.includes(element.dimensionSlug)) {
      return true;
    } else {
      return false;
    }
  }
}

export function filterByNature(element: TraitElement, nature: string[]) {
  if (nature.length === 0) {
    return true;
  }
  if (
    element.traitContent.nature &&
    // @ts-ignore
    nature.includes(element.traitContent.nature)
  ) {
    return true;
  } else {
    return false;
  }
}

export function filterByArchetype(
  element: TraitElement,
  archetypeType: string[]
) {
  if (archetypeType.length === 0) {
    return true;
  }

  if (
    // @ts-ignore
    element.archetypeGroupSlug &&
    // @ts-ignore
    archetypeType.includes(element.archetypeGroupSlug)
  ) {
    return true;
  } else {
    return false;
  }
}

export function sortElements(a: TraitElement, b: TraitElement, sort: string) {
  if (sort === "alphabetically") {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  } else {
    if (
      a.traitContent.averagePercentScore &&
      b.traitContent.averagePercentScore
    ) {
      if (
        a.traitContent.averagePercentScore < b.traitContent.averagePercentScore
      ) {
        return -1;
      }
      if (
        a.traitContent.averagePercentScore > b.traitContent.averagePercentScore
      ) {
        return 1;
      }

      return 0;
    } else {
      return 0;
    }
  }
}
